module.exports = __webpack_public_path__ + "images/business-class-logo-white.a39acf1a121f661bd1ad.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/business-class-logo-white.svg
// module id = JDAN
// module chunks = 0